import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type TablePageSizeState = {
  pageSizeByTable: Record<string, number>
  setPageSize: (tableKey: string, pageSize: number) => void
}

export const useTablePageSizeStore = create<TablePageSizeState>()(
  persist(
    set => ({
      pageSizeByTable: {},
      setPageSize: (tableKey, pageSize) =>
        set(state => ({
          pageSizeByTable: { ...state.pageSizeByTable, [tableKey]: pageSize },
        })),
    }),
    { name: 'table-page-size' }
  )
)

export const TABLE_PAGE_SIZE_KEYS = {
  PLANS_LIST: 'plans-list',
  WAVE_PLANS_LIST: 'wave-plans-list',
  DELETED_PLANS_LIST: 'deleted-plans-list',
  PLAN_LINE_ITEMS: 'plan-line-items',
  APPROVAL_LINE_ITEMS: 'approval-line-items',
  APPROVALS_LIST: 'approvals-list',
  ADMIN_STORE_MODELS_LIST: 'admin-store-models-list',
  STORE_MODEL_MEMBERS: 'store-model-members',
  STORE_GROUP_MEMBERS: 'store-group-members',
  ADMIN_STORE_GROUPS_LIST: 'admin-store-groups-list',
  ADMIN_USERS_LIST: 'admin-users-list',
  ADMIN_STORES_LIST: 'admin-stores-list',
  ADMIN_ASSORTMENT_ACCESS_LIST: 'admin-assortment-access-list',
  ADMIN_CALENDARS_LIST: 'admin-calendars-list',
  ADMIN_WAREHOUSE_LOOKUP_ENTRIES: 'admin-warehouse-lookup-entries',
  ADMIN_IMAGES_LIST: 'admin-images-list',
  NOTIFICATIONS_LIST: 'notifications-list',
  BROWSE_PLANS_GRID: 'browse-plans-grid',
  PLAN_HISTORY: 'plan-history',
  ASSIGN_STORE_MODEL_STORES: 'assign-store-model-stores',
  CALENDAR_LOOKUP_TABLE: 'calendar-lookup-table',
} as const
